/**
 * Primitive Relationships from Domain Registry
 *
 * Transforms EDGE_CATALOG into UI-friendly relationship data
 * Single source of truth: @unwritten/domain-registry
 */
import { EDGE_CATALOG } from '@unwritten/domain-registry';
/**
 * Core primitives for UI visualization
 */
const CORE_PRIMITIVE_IDS = [
    'memory',
    'template',
    'card',
    'beat',
    'goal',
    'canon',
    'player',
    'npc',
    'character',
    'season',
    'world',
    'game',
];
/**
 * Map cardinality to relationship type
 */
function mapCardinality(_cardinality) {
    // All edges from EDGE_CATALOG are edge tables in SurrealDB
    return 'edge_table';
}
/**
 * Build primitive relationships from domain registry
 */
function buildPrimitiveRelationships() {
    const relationships = {};
    // Initialize all core primitives
    CORE_PRIMITIVE_IDS.forEach((id) => {
        relationships[id] = [];
    });
    // Transform edges into relationships
    for (const edge of EDGE_CATALOG) {
        const source = edge.from;
        const target = edge.to;
        // Only include if source is a core primitive
        if (!CORE_PRIMITIVE_IDS.includes(source)) {
            continue;
        }
        if (!relationships[source]) {
            relationships[source] = [];
        }
        relationships[source].push({
            field: edge.fieldName || edge.id,
            targetPrimitive: target,
            relationshipType: mapCardinality(edge.cardinality),
            fieldType: edge.cardinality,
            description: edge.label,
        });
    }
    return relationships;
}
/**
 * Primitive relationships derived from domain-registry
 */
export const PRIMITIVE_RELATIONSHIPS = buildPrimitiveRelationships();
/**
 * Get all relationships for a specific primitive
 */
export function getRelationshipsForPrimitive(primitiveId) {
    return PRIMITIVE_RELATIONSHIPS[primitiveId] || [];
}
/**
 * Get relationship count for a primitive
 */
export function getRelationshipCount(primitiveId) {
    return (PRIMITIVE_RELATIONSHIPS[primitiveId] || []).length;
}
/**
 * Get all primitives that a given primitive relates to
 */
export function getRelatedPrimitives(primitiveId) {
    const relationships = PRIMITIVE_RELATIONSHIPS[primitiveId] || [];
    return [...new Set(relationships.map((rel) => rel.targetPrimitive))];
}
